import { CustomerDto, ServiceDto, ContactDto, InfoDto } from '../generated/backend/models';
import {
  CollectedServiceDetail,
  mapCollectedServiceDetailsDto,
} from './collected-services.utils';

export interface CustomersGroupedByStartLetter {
  letter: string;
  customers: Customer[];
}

export interface Customer {
  address?: null | string;
  availableServices: Array<ServiceDto>;
  city?: null | string;
  collectedServices: Array<CollectedServiceDetail>;
  email?: null | string;
  firstName?: null | string;
  id?: number;
  lastName?: null | string;
  mobileNumber?: null | string;
  phoneNumber?: null | string;
  salutation?: null | string;
  zipCode?: null | string;
  contacts?: Array<ContactDto> | null;
  infos?: Array<InfoDto> | null;
}

export const groupAlphabetically = (
  list: Customer[]
): CustomersGroupedByStartLetter[] => {
  return Object.values(
    list.reduce((accumulator, customer) => {
      const startLetter =
        (customer.lastName as string)[0].toLocaleUpperCase() || ' ';
      if (!accumulator[startLetter]) {
        accumulator[startLetter] = {
          letter: startLetter,
          customers: [customer],
        };
      } else {
        accumulator[startLetter].customers = [
          ...accumulator[startLetter].customers,
          customer,
        ];
      }
      return accumulator;
    }, {} as { [startLetter: string]: CustomersGroupedByStartLetter })
  ).sort((customer1, customer2) =>
    customer1.letter.localeCompare(customer2.letter)
  );
};

export const mapCustomerDto = (customerDto: CustomerDto): Customer => {
  return {
    address: customerDto.address,
    availableServices: customerDto.availableServices || [],
    city: customerDto.city,
    collectedServices: mapCollectedServiceDetailsDto(
      customerDto.collectedServices
    ),
    email: customerDto.email,
    firstName: customerDto.firstName,
    id: customerDto.id,
    lastName: customerDto.lastName,
    mobileNumber: customerDto.mobileNumber,
    phoneNumber: customerDto.phoneNumber,
    salutation: customerDto.salutation,
    zipCode: customerDto.zipCode,
    contacts: customerDto.contacts ?? [],
    infos: customerDto.infos ?? [],
  };
};
